import { useState } from 'react';
import { usePurchaseOrders } from '@/hooks/usePurchaseOrders';
import { PurchaseOrderCard } from '@/components/purchase-orders/PurchaseOrderCard';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PurchaseOrdersPage() {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const navigate = useNavigate();

  const { purchaseOrders, loading, error } = usePurchaseOrders({
    status: statusFilter || undefined,
    search: search || undefined
  });

  const handleViewPO = (poId: string) => {
    navigate(`/purchase-orders/${poId}`);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Purchase Orders</h1>
      </div>

      <div className="flex gap-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search purchase orders..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-10"
          />
        </div>
        <Select value={statusFilter || 'all'} onValueChange={(value) => setStatusFilter(value === 'all' ? '' : value)}>
          <SelectTrigger className="w-48">
            <SelectValue placeholder="Filter by status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Statuses</SelectItem>
            <SelectItem value="draft">Draft</SelectItem>
            <SelectItem value="sent">Sent</SelectItem>
            <SelectItem value="acknowledged">Acknowledged</SelectItem>
            <SelectItem value="in_progress">In Progress</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="text-center py-8">Loading purchase orders...</div>
      ) : error ? (
        <div className="text-center py-8 text-destructive">Error: {error}</div>
      ) : (
        <div className="grid gap-4">
          {purchaseOrders.map((po) => (
            <PurchaseOrderCard
              key={po.id}
              purchaseOrder={po}
              onView={handleViewPO}
            />
          ))}
          {purchaseOrders.length === 0 && (
            <div className="text-center py-8 text-muted-foreground">
              No purchase orders found.
            </div>
          )}
        </div>
      )}
    </div>
  );
}